import { Component, ErrorInfo, ReactNode } from "react";

interface ErrorBoundaryProps {
  children: ReactNode;
  fallback?: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

// ErrorBoundary global que evita a tela branca quando algum componente lanca
// erro fora dos handlers de eventos. Apenas a arvore que falhar e substituida
// pelo fallback; o resto da pagina (toasts, modais, etc.) continua respondendo.
export class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): ErrorBoundaryState {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error("ErrorBoundary caught:", error, info.componentStack);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    if (this.props.fallback) return this.props.fallback;

    return (
      <div
        className="d-flex flex-column align-items-center justify-content-center text-center p-4"
        style={{ minHeight: "100vh" }}
      >
        <h2 className="mb-2">Algo deu errado.</h2>
        <p className="text-muted mb-3">
          Ocorreu um erro inesperado. Tente recarregar a pagina.
        </p>
        <button
          type="button"
          className="btn btn-primary"
          onClick={this.handleReload}
        >
          Recarregar
        </button>
      </div>
    );
  }
}
